import { Box, Button, Card, Grid, Hidden, Typography, useMediaQuery } from '@material-ui/core'
import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { useSubscriptionDetails } from '../../hooks/subscriptions'
import { subscriptionsPromoRoute } from '../../routes/routes'
import { pushAnalyticsEvent } from '../../util/gtmUtils'
const HIDE_SUBSCRIPTION_PROMO_KEY = 'SubscriptionPromotional-optOut'

export const SubscriptionPromotional = ({ ...rest }) => {
  const [optedOut, setOptedOut] = useState(
    !!window?.localStorage?.getItem(HIDE_SUBSCRIPTION_PROMO_KEY),
  )
  const { subscriptionDetails, subscriptionEligible } = useSubscriptionDetails()
  const history = useHistory()
  const matchesSmUp = useMediaQuery(theme => theme.breakpoints.up('sm')) // Breakpoint for responsive styles
  const isEligible = // Specific to promotional. Not a subscription.
    (isEmpty(subscriptionDetails) || subscriptionDetails?.status === 'UNSUBSCRIBED') && // Haven't had a prev subscription, or is unsubscribed
    subscriptionEligible
  useEffect(() => {
    if (isEligible && !optedOut) {
      pushAnalyticsEvent('Subscriptions', 'Promo Card - View')
    }
  }, [isEligible, optedOut])

  return (
    <StyledCard isEligible={isEligible} matchesSmUp={matchesSmUp} optedOut={optedOut} {...rest}>
      <Grid container spacing={matchesSmUp ? 4 : 2} wrap="nowrap">
        <Grid item>
          <img
            alt=""
            className="-carModel"
            src="https://images.foodsby.com/conweb/unlimited_delivery_promo_5242020.svg"
          />
        </Grid>
        <Grid container item>
          <Typography variant="h6">Unlimited Delivery</Typography>
          <Typography component="p" gutterBottom variant="body1">
            Say goodbye to delivery fees with Unlimited Delivery.{' '}
            {!subscriptionDetails
              ? 'Get your first month free and cancel anytime.'
              : 'Cancel anytime.'}
          </Typography>
          <Grid component={Box} display="flex" item justify="flex-end" width="100%">
            <Hidden xsDown>
              <PromoActions
                history={history}
                setOptedOut={setOptedOut}
                subscriptionDetails={subscriptionDetails}
                subscriptionsPromoRoute={subscriptionsPromoRoute}
              />
            </Hidden>
          </Grid>
        </Grid>
      </Grid>
      <Hidden smUp>
        <PromoActions
          display="flex"
          history={history}
          justifyContent="center"
          setOptedOut={setOptedOut}
          subscriptionDetails={subscriptionDetails}
          subscriptionsPromoRoute={subscriptionsPromoRoute}
        />
      </Hidden>
    </StyledCard>
  )
}

const PromoActions = ({
  history,
  setOptedOut,
  subscriptionDetails,
  subscriptionsPromoRoute,
  ...rest
}) => (
  <Box {...rest}>
    <Button
      color="secondary"
      onClick={() => history.push(subscriptionsPromoRoute.path)}
      style={{ marginRight: '16px' }}
      variant="outlined"
    >
      {subscriptionDetails ? 'SUBSCRIBE' : 'TRY FOR FREE'}
    </Button>
    <Button
      color="primary"
      onClick={() => {
        setOptedOut(true)
        window.localStorage.setItem(HIDE_SUBSCRIPTION_PROMO_KEY, new Date())
      }}
    >
      Dismiss
    </Button>
  </Box>
)

const StyledCard = styled(Card)`
  display: ${({ isEligible, optedOut }) => (!isEligible || optedOut ? 'none' : 'flex')};
  flex-direction: column;
  width: 100%;
  padding: 16px;
  margin-bottom: 8px;

  & .-carModel {
    ${({ matchesSmUp }) =>
      matchesSmUp ? 'width: 160px; min-width: 160px;' : 'width: 100px; min-width: 100px;'}
  }
`

export default SubscriptionPromotional
